export default __webpack_public_path__ + "assets/icons/th.43d63a71.svg";